import '@tap/tap-ui/src/fonts/index.css';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { BrowserRouter } from 'react-router';
import { SnackbarProvider } from 'notistack';
import { SessionProvider, UserRole, AppCode } from '@tap/tap-ui';
import ReactDOM from 'react-dom/client';
import App from './App';
import axios from 'axios';
import { DocumentSchemaProvider } from '@tap/doc-ui';
import { MainTheme } from '@tap/mui-ui';


axios.defaults.baseURL = '';
axios.defaults.withCredentials = true;

axios.interceptors.request.use(function (config) {
    return config;
});

axios.interceptors.response.use(
    response => response,
    error => {
        const { status } = error.response;
        if (status !== 401) {
            throw error;
        }
    },
);

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <BrowserRouter>
        <SnackbarProvider
            maxSnack={3}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
        >
            <ThemeProvider theme={MainTheme}>
                <CssBaseline />
                <SessionProvider userRole={UserRole.Plan} appCode={AppCode.Documents}>
                    <DocumentSchemaProvider>
                        <App />
                    </DocumentSchemaProvider>
                </SessionProvider>
            </ThemeProvider>
        </SnackbarProvider>
    </BrowserRouter>,
)
